import { AppService, CoreProxyService, CoreTypes, IncidentsService, LabelValue } from 'common-cloudstudio';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IncidentService {
  _assetsFullList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _assetsList: BehaviorSubject<CoreTypes.Asset[]> = new BehaviorSubject([]);
  _assetsStatus = 0;
  _externalServiceFullList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _externalServiceList: BehaviorSubject<CoreTypes.ITS_ExternalAssistanceServices[]> = new BehaviorSubject([]);
  _externalServiceStatus = 0;
  _vialAxesFullList:BehaviorSubject<CoreTypes.ITS_VialAxes[]> = new BehaviorSubject([]);
  _vialAxesStatus = 0;
  _incidentTypeList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _incidentTypeFullList: BehaviorSubject<CoreTypes.IncidentType[]> = new BehaviorSubject([]);
  _incidentTypeStatus = 0;
  _incidentSubTypeList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _incidentSubTypeFullList: BehaviorSubject<CoreTypes.IncidentSubType[]> = new BehaviorSubject([]);
  _incidentSubTypeStatus = 0;
  _geozonesList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _geozonesStatus = 0;
  _vehicleModelsFullList:BehaviorSubject<CoreTypes.ITS_VehicleModels[]> = new BehaviorSubject([]);
  _vehicleModelsList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _vehicleModelsStatus = 0;
  _vehicleMakesFullList:BehaviorSubject<CoreTypes.ITS_VehicleMakes[]> = new BehaviorSubject([]);
  _vehicleMakesList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _vehicleMakesStatus = 0;
  _vehicleColorFullList:BehaviorSubject<CoreTypes.ITS_VehicleColors[]> = new BehaviorSubject([]);
  _vehicleColorList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _vehicleColorStatus = 0;
  _vehicleTypesFullList:BehaviorSubject<CoreTypes.ITS_VehicleTypes[]> = new BehaviorSubject([]);
  _vehicleTypesList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _vehicleTypesStatus = 0;
  _vehicleDataFullList: BehaviorSubject<CoreTypes.ITS_VehiclesData[]> = new BehaviorSubject([]);
  _vehicleDataStatus = 0;
  _trafficDirectionsFullList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _trafficDirectionsList: BehaviorSubject<CoreTypes.ITS_TrafficDirection[]> = new BehaviorSubject([]);
  _trafficDirectionsStatus = 0;
  _countriesFullList: BehaviorSubject<CoreTypes.ITS_Countries[]> = new BehaviorSubject([]);
  _countriesList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _countriesStatus = 0;
  _insuranceCompaniesFullList: BehaviorSubject<CoreTypes.ITS_InsuranceCompanies[]> = new BehaviorSubject([]);
  _insuranceCompaniesList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _insuranceCompaniesStatus = 0;
  _prioritiesFullList: BehaviorSubject<CoreTypes.IncidentPriority[]> = new BehaviorSubject([]);
  _prioritiesStatus = 0;
  _incidentStatusFullList: BehaviorSubject<CoreTypes.IncidentStatus[]> = new BehaviorSubject([]);
  _incidentStatusList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _incidentStatus = 0;
  _documentTypeFullList: BehaviorSubject<CoreTypes.ITS_DocumentTypes[]> = new BehaviorSubject([]);
  _documentTypeList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _documentTypeStatus = 0
  _healthConditionFullList: BehaviorSubject<CoreTypes.ITS_HealthConditions[]> = new BehaviorSubject([]);
  _healthConditionList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _healthConditionStatus = 0
  _responsibilitiesFullList: BehaviorSubject<CoreTypes.ITS_DamageResponsibilities[]> = new BehaviorSubject([]);
  _responsibilitiesList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _responsibilitiesStatus = 0
  _personTypeFullList: BehaviorSubject<CoreTypes.ITS_PersonTypes[]> = new BehaviorSubject([]);
  _personTypeList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _personTypeStatus = 0;
  _assistenceTypeFullList: BehaviorSubject<CoreTypes.ITS_AssistanceTypes[]> = new BehaviorSubject([]);
  _assistenceTypeList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _assistenceTypeStatus = 0;
  _personAssistanceFullList: BehaviorSubject<CoreTypes.ITS_PersonAssistanceReasons[]> = new BehaviorSubject([]);
  _personAssistanceList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _personAssistanceStatus = 0;
  _hospitalsFullList: BehaviorSubject<CoreTypes.ITS_Hospitals[]> = new BehaviorSubject([]);
  _hospitalsList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _hospitalsStatus = 0;
  _personsDataFullList:BehaviorSubject<CoreTypes.ITS_Persons[]> = new BehaviorSubject([]);
  _personsDataStatus = 0;
  _attachmentTypesFullList:BehaviorSubject<CoreTypes.IncidentAttachmentType[]> = new BehaviorSubject([]);
  _attachmentTypesStatus = 0;
  _reasonCloseFullList:BehaviorSubject<CoreTypes.ITS_IncidentLaneClosureReasons[]> = new BehaviorSubject([]);
  _reasonCloseList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _reasonCloseStatus = 0;
  _reasonOpenFullList:BehaviorSubject<CoreTypes.ITS_IncidentLaneOpeningReasons[]> = new BehaviorSubject([]);
  _reasonOpenList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _reasonOpenStatus = 0;
  _damagesElements: any[] = [];
  _materialAssetsFullList:BehaviorSubject<CoreTypes.ITS_MaterialAssets[]> = new BehaviorSubject([]);
  _materialAssetsStatus = 0;
  _roadwaysFullList:BehaviorSubject<CoreTypes.ITS_Roadways[]> = new BehaviorSubject([]);
  _roadwaysList:BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _roadwaysStatus = 0;
  _roadwayLanesFullList:BehaviorSubject<CoreTypes.ITS_RoadWaysLanes[]> = new BehaviorSubject([]);
  _roadwaylanesList:BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _roadwayLanesStatus = 0;
  _lanesFullList:BehaviorSubject<CoreTypes.ITS_Lanes[]> = new BehaviorSubject([]);
  _lanesList:BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _lanesStatus = 0;
  _assistenceReasonFullList:BehaviorSubject<CoreTypes.ITS_VehicleAssistanceReasons[]> = new BehaviorSubject([]);
  _assistenceReasonList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _assistenceReasonStatus = 0;
  _sectorFullList:BehaviorSubject<CoreTypes.ITS_Sectors[]> = new BehaviorSubject([]);
  _sectorList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _sectorStatus = 0;
  _subSectorFullList:BehaviorSubject<CoreTypes.ITS_SubSectors[]> = new BehaviorSubject([]);
  _subSectorList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _subSectorStatus = 0;
  _subSectorsFullList:BehaviorSubject<CoreTypes.ITS_SubSectors[]> = new BehaviorSubject([]);
  _subSectorsList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _subSectorsStatus = 0;
  _issuersFullList:BehaviorSubject<CoreTypes.ITS_CommunicationIssuers[]> = new BehaviorSubject([]);
  _issuersList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _issuersStatus = 0;
  _communicationTypesFullList:BehaviorSubject<CoreTypes.ITS_CommunicationTypes[]> = new BehaviorSubject([]);
  _communicationTypesList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _communicationTypesStatus = 0;
  _incidentOriginFullList:BehaviorSubject<CoreTypes.IncidentOrigin[]> = new BehaviorSubject([]);
  _incidentOriginList: BehaviorSubject<LabelValue<number>[]> = new BehaviorSubject([]);
  _incidentOriginStatus = 0;
  sectionSelections: { [sectionId: string]: BehaviorSubject<any[]> } = {};
  _referenceFullList: CoreTypes.ITS_ReferencePoints[] = [];
  _assistanceDispacthList: any[] = [];
  _emergencyVehiclesList: any[] = [];
  _reference: LabelValue<string>;
  _roadway:LabelValue<number>;
  _vialAxesList:LabelValue<number>[] = [];
  _vialAxes:LabelValue<number>;
  vehiclePersonList: LabelValue<number>[] = [{label: 'Ninguno',value: 0}];
  private _pendingRequests: { [key: string]: Array<(data: any) => void> } = {};
  onRefreshIncidentList: BehaviorSubject<boolean> = new BehaviorSubject(null);
  onRefreshCommunicationList: BehaviorSubject<boolean> = new BehaviorSubject(null);


  constructor(
    public appService: AppService,
    private coreProxyService: CoreProxyService,
  ) { 
    this.appService.onFacilitySet.subscribe(() => {
      this.cleanVariablesFacility();
    });

    this.appService.onClientSet.subscribe(() => {
     this.cleanVariablesClient();
    })
  }

  getITSRoadways():Promise<CoreTypes.ITS_Roadways[]> {
    return new Promise((resolve, reject) => {
      if (this._roadwaysFullList.value.length || this._roadwaysStatus === 1) { 
        return resolve(this._roadwaysFullList.value);
      }
      this._roadwaysStatus = 1;
      this.coreProxyService.IncidentService.EnumITSRoadways(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        async data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x.Description, value: x.RoadwayID };
            optionsList.push(item);
          });
          this._roadwaysFullList.next(data);
          this._roadwaysList.next(optionsList);
          resolve(data);
        },
        error => {
          this.appService.showException(error);
          reject(error)
        }
      )
    })
  }

  getITSRoadwayLanes(vialAxis:number, roadwayID: number, directionID: number):Promise<CoreTypes.ITS_RoadWaysLanes[]> {
    return new Promise((resolve, reject) => {
      if (this._roadwayLanesFullList.value.length || this._roadwayLanesStatus === 1) { 
        return resolve(this._roadwayLanesFullList.value);
      }
      this._roadwayLanesStatus = 1;
      this.coreProxyService.IncidentService.EnumITSRoadwayLanes(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        vialAxis,
        roadwayID,
        directionID,
        this.appService.getFacilityID(),
        async data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x.LaneName, value: x.LaneID };
            optionsList.push(item);
          });
          this._roadwayLanesFullList.next(data);
          this._roadwaylanesList.next(optionsList);
          resolve(data);
        },
        error => {
          this.appService.showException(error);
          reject(error)
        }
      )
    })
  }

  getITSLanes():Promise<CoreTypes.ITS_Lanes[]> {
    return new Promise((resolve, reject) => {
      if (this._lanesFullList.value.length || this._lanesStatus === 1) { 
        return resolve(this._lanesFullList.value);
      }
      this._lanesStatus = 1;
      this.coreProxyService.IncidentService.EnumITSLanes(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        async data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x.LaneName, value: x.LaneID };
            optionsList.push(item);
          });
          this._lanesFullList.next(data);
          this._lanesList.next(optionsList);
          resolve(data);
        },
        error => {
          this.appService.showException(error);
          reject(error);
        }
      );
    })
  }

  getAssetsList(): Promise<LabelValue<number>[]> {
    let serviceKey = 'Assets'
    return new Promise((resolve, reject) => {
      if (!this._pendingRequests[serviceKey]) { this._pendingRequests[serviceKey] = []; }

      if (this._assetsStatus === 2 && this._assetsFullList.value.length) {
        return resolve(this._assetsFullList.value);
      }
  
      if (this._assetsStatus === 1) {
        this._pendingRequests[serviceKey].push(resolve);
        return;
      }
  
      this._assetsStatus = 1;
      this._pendingRequests[serviceKey].push(resolve);
  
      this.coreProxyService.AssetService.EnumAssets(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        async data => {
          let optionsList: LabelValue<number>[] = [];
          if (data.length) {
            optionsList.push({
              label: this.appService.CoreCommonLiterals.None_Male,
              value: 0
            });
          }
  
          data.forEach(x => {
            let item = { label: x.DisplayDescription, value: x.AssetID };
            optionsList.push(item);
          });
          this._assetsList.next(data);
          this._assetsFullList.next(optionsList);
          this._assetsStatus = 2;
          this._pendingRequests[serviceKey]?.forEach(pendingResolve => pendingResolve(optionsList));
          this._pendingRequests[serviceKey] = []; 
        },
        error => {
          this.appService.showException(error);
          this._assetsStatus = 0;
          this._pendingRequests[serviceKey] = [];
          reject(error);
        }
      );
    });
  }
  
  getITSExternalAssistanceServices(): Promise<LabelValue<number>[]>  {
    return new Promise((resolve, reject) => {
      if (this._externalServiceFullList.value.length || this._externalServiceStatus === 1) { 
        return resolve(this._externalServiceFullList.value);
      }
      this._externalServiceStatus = 1;
      this.coreProxyService.IncidentService.EnumITSExternalAssistanceServices(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        async data => {
          let optionsList: LabelValue<number>[] = [];
          if(data.length) {
            optionsList.push({
              label: this.appService.CoreCommonLiterals.None_Male,
              value: 0
            });
          }
          data.forEach((x) => {
            let item = { label: x.ServiceName, value: x.ServiceID };
            optionsList.push(item);
          });
          this._externalServiceList.next(data);
          this._externalServiceFullList.next(optionsList);
          resolve(optionsList);
        },
        error => {
          this.appService.showException(error);
          reject(error)
        }
      )
    })
  }

  getITSReasonsClosing():Promise<CoreTypes.ITS_IncidentLaneClosureReasons[]> {
    return new Promise((resolve, reject) => {
      if (this._reasonCloseFullList.value.length || this._reasonCloseStatus === 1) { 
        return resolve(this._reasonCloseFullList.value);
      }
      this._reasonCloseStatus = 1;
      this.coreProxyService.IncidentService.EnumITSIncidentLaneClosureReasons(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { 
              label: x.IncidentLaneClosureReasonName ? x.IncidentLaneClosureReasonName : x.IncidentLaneClosureReasonDescription, 
              value: x.IncidentLaneClosureReasonID 
            };
            optionsList.push(item);
          });
          this._reasonCloseFullList.next(data);
          this._reasonCloseList.next(optionsList);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getITSReasonsOpening():Promise<CoreTypes.ITS_IncidentLaneOpeningReasons[]> {
    return new Promise((resolve, reject) => {
      if (this._reasonOpenFullList.value.length || this._reasonOpenStatus === 1) { 
        return resolve(this._reasonOpenFullList.value);
      }
      this._reasonOpenStatus = 1;
      this.coreProxyService.IncidentService.EnumITSIncidentLaneOpeningReasons(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { 
              label: x.IncidentLaneOpeningReasonName ? x.IncidentLaneOpeningReasonName : x.IncidentLaneOpeningReasonDescription, 
              value: x.IncidentLaneOpeningReasonID 
            };
            optionsList.push(item);
          });
          this._reasonOpenFullList.next(data);
          this._reasonOpenList.next(optionsList);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getITSVialAxes(): Promise<CoreTypes.ITS_VialAxes[]> {
    return new Promise((resolve, reject) => {
      if (this._vialAxesFullList.value.length || this._vialAxesStatus === 1) { 
        return resolve(this._vialAxesFullList.value);
      }
      this._vialAxesStatus = 1;
      this.coreProxyService.IncidentService.EnumITSVialAxes(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          this._vialAxesFullList.next(data);
          resolve(data);
        },
        error => {
          this.appService.showException(error);
          reject(error)
        }
      )
    })
  }

  getITSTrafficDirections(): Promise<LabelValue<number>[]> {
    let serviceKey = 'TrafficDirections'
    return new Promise((resolve, reject) => {
      if (!this._pendingRequests[serviceKey]) { this._pendingRequests[serviceKey] = []; }

      if (this._trafficDirectionsStatus === 2 && this._trafficDirectionsFullList.value.length) {
        return resolve(this._trafficDirectionsFullList.value);
      }
  
      if (this._trafficDirectionsStatus === 1) {
        this._pendingRequests[serviceKey].push(resolve);
        return;
      }
  
      this._trafficDirectionsStatus = 1;
      this._pendingRequests[serviceKey].push(resolve);
   
      this.coreProxyService.IncidentService.EnumITSTrafficDirections(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x.Description, value: x.DirectionID };
            optionsList.push(item);
          });
          this._trafficDirectionsList.next(data);
          this._trafficDirectionsFullList.next(optionsList);
          this._trafficDirectionsStatus = 2;
          this._pendingRequests[serviceKey]?.forEach(pendingResolve => pendingResolve(optionsList));
          this._pendingRequests[serviceKey] = []; 
        },
        err => {
          this.appService.showException(err);
          this._trafficDirectionsStatus = 0;
          this._pendingRequests[serviceKey] = []; 
          reject(err)
        }
      );
    })
  }

  getIncidentTypes(): Promise<CoreTypes.IncidentType[]> {
    return new Promise((resolve, reject) => {
      if (this._incidentTypeFullList.value.length || this._incidentTypeStatus === 1) { 
        return resolve(this._incidentTypeFullList.value);
      }
      this._incidentTypeStatus = 1;
      this.coreProxyService.IncidentService.EnumClientIncidentTypes(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        data => {
          let items: LabelValue<number>[] = [];
          data.forEach((i) => {
            const item = {
              label: i.Description,
              value: i.IncidentTypeID,
            };
            items.push(item);
          });
          this._incidentTypeList.next(items);
          this._incidentTypeFullList.next(data);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  }

  
  getIncidentubTypes(): Promise<CoreTypes.IncidentSubType[]> {
    return new Promise((resolve, reject) => {
      if (this._incidentSubTypeFullList.value.length || this._incidentSubTypeStatus === 1) { 
        return resolve(this._incidentSubTypeFullList.value);
      }
      this._incidentSubTypeStatus = 1;
      this.coreProxyService.IncidentService.EnumClientIncidentSubTypes(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let items: LabelValue<number>[] = [];
          data.forEach((i) => {
            const item = {
              label: i.SubtypeName ? i.SubtypeName : i.Description,
              value: i.IncidentTypeID,
            };
            items.push(item);
          });
          this._incidentSubTypeList.next(items);
          this._incidentSubTypeFullList.next(data);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  }

  getPriorities(): Promise<CoreTypes.IncidentPriority[]> {
    return new Promise((resolve, reject) => {
      if (this._prioritiesFullList.value.length || this._prioritiesStatus === 1) { 
        return resolve(this._prioritiesFullList.value);
      }
      this._prioritiesStatus = 1;
      this.coreProxyService.IncidentService.EnumClientIncidentPriorities(
        this.appService.getAccessToken(),
        this.appService.getClientID(), 
        res => {
          this._prioritiesFullList.next(res);
          resolve(res);
        }, (err) => {
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  }
  
  getIncidentStatus(): Promise<CoreTypes.IncidentStatus[]>{
    return new Promise((resolve, reject) => {
      if (this._incidentStatusFullList.value.length || this._incidentStatus === 1) { 
        return resolve(this._incidentStatusFullList.value);
      }
      this._incidentStatus = 1;
      this.coreProxyService.IncidentService.EnumClientIncidentStatus(
        this.appService.getAccessToken(), 
        this.appService.getClientID(),
        data => {
          let items: LabelValue<number>[] = [];
          data.forEach((i) => {
            const item = {
              label: i.IncidentStatusName,
              value: i.IncidentStatusID,
            };
            items.push(item);
          });
          this._incidentStatusList.next(items);
          this._incidentStatusFullList.next(data);
          resolve(data);
        }, err => {
          this.appService.showException(err);
          reject(err);
        }
      )
    })
  }

  getVehicleModels(): Promise<CoreTypes.ITS_VehicleModels[]> {
    return new Promise((resolve, reject) => {
      if (this._vehicleModelsFullList.value.length || this._vehicleModelsStatus === 1) { 
        return resolve(this._vehicleModelsFullList.value);
      }
      this._vehicleModelsStatus = 1;
      this.coreProxyService.IncidentService.EnumITSVehicleModels(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          if(data.length) {
            optionsList.push({ label: 'Sin Determinar', value: 0 });
          }
          data.forEach((x) => {
            let item = { label: x.ModelDisplay, value: x.ModelID };
            optionsList.push(item);
          });
          this._vehicleModelsList.next(optionsList)
          this._vehicleModelsFullList.next(data);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  }

  getITSVehicleModels(makesIDs:number[]): Promise<CoreTypes.ITS_VehicleModels[]>{
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.GetITSVehicleModels(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        makesIDs,
        data => {
          let optionsList: LabelValue<number>[] = [];
          if(data.length) {
            optionsList.push({ label: 'Sin Determinar', value: 0 });
          }
          data.forEach((x) => {
            let item = { label: x.ModelDisplay, value: x.ModelID };
            optionsList.push(item);
          });
          this._vehicleModelsList.next(optionsList)
          this._vehicleModelsFullList.next(data);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  }

  getVehicleMakes(): Promise<CoreTypes.ITS_VehicleMakes[]> {
    return new Promise((resolve, reject) => {
      if (this._vehicleMakesFullList.value.length || this._vehicleMakesStatus === 1) { 
        return resolve(this._vehicleMakesFullList.value);
      }

      this.coreProxyService.IncidentService.EnumITSVehicleMakes(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
        this._vehicleMakesStatus = 1;
          let optionsList: LabelValue<number>[] = [];
          if(data.length) {
            optionsList.push({ label: 'Sin Determinar', value: 0 });
          }
          data.forEach((x) => {
            let item = { label: x.MakeName, value: x.MakeID };
            optionsList.push(item);
          });
          this._vehicleMakesList.next(optionsList);
          this._vehicleMakesFullList.next(data);
          resolve(data);
        },
        err => {
          this._vehicleMakesStatus = 2;
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  } 

  getVehicleColor(): Promise<CoreTypes.ITS_VehicleColors[]> {
    return new Promise((resolve, reject) => {
      if (this._vehicleColorFullList.value.length || this._vehicleColorStatus === 1) { 
        return resolve(this._vehicleColorFullList.value);
      }
      this.coreProxyService.IncidentService.EnumITSVehicleColors(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          this._vehicleColorStatus = 1;
          let optionsList: LabelValue<number>[] = [];
          if(data.length) {
            optionsList.push({ label: 'Sin Determinar', value: 0 });
          }
          data.forEach((x) => {
            let item = { label: x.VehicleColorName, value: x.VehicleColorID };
            optionsList.push(item);
          });
          this._vehicleColorList.next(optionsList);
          this._vehicleColorFullList.next(data);
          resolve(data);
        },
        err => {
          this._vehicleColorStatus = 2;
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  }

  getVehicleTypes(): Promise<CoreTypes.ITS_VehicleTypes[]> {
    return new Promise((resolve, reject) => {
      if (this._vehicleTypesFullList.value.length || this._vehicleTypesStatus === 1) { 
        return resolve(this._vehicleTypesFullList.value);
      }
      this.coreProxyService.IncidentService.EnumITSVehicleTypes(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          this._vehicleTypesStatus = 1;
          let optionsList: LabelValue<number>[] = [];
          if(data.length) {
            optionsList.push({ label: 'Sin Determinar', value: 0 });
          }
          data.forEach((x) => {
            let item = { label: x.TypeName, value: x.TypeID };
            optionsList.push(item);
          });
          this._vehicleTypesList.next(optionsList)
          this._vehicleTypesFullList.next(data);
          resolve(data);
        },
        err => {
          this._vehicleTypesStatus = 2;
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  }

  getVehiclesData(): Promise<CoreTypes.ITS_VehiclesData[]> {
    return new Promise((resolve, reject) => {
      if (this._vehicleDataFullList.value.length || this._vehicleDataStatus === 1) { 
        return resolve(this._vehicleDataFullList.value);
      }
      this._vehicleDataStatus = 1;
      this.coreProxyService.IncidentService.EnumITSVehiclesData(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          this._vehicleDataFullList.next(data);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err)
        }
      )
    })
  }
  
  getITSVehicles(vehicleIDs:number[]): Promise<CoreTypes.ITS_VehiclesData[]> {
    return new Promise((resolve, reject) => {
      if(vehicleIDs?.length) {
        this.coreProxyService.IncidentService.GetITSVehicles(
          this.appService.getAccessToken(),
          this.appService.getFacilityID(),
          vehicleIDs,
          data => {
            resolve(data);
          },
          err => {
            this.appService.showException(err);
            reject(err)
          }
        )
      } else {
        resolve([]);
      }
    })
    
  }

  getITSVehicle(vehicleID): Promise<CoreTypes.ITS_VehiclesData> {
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.GetITSVehicle(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        vehicleID,
        data => {
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err)
        }
      )
    }) 
  }
  
  loadCountries() {
    return new Promise((resolve, reject) => {
      if (this._countriesFullList.value.length || this._countriesStatus === 1) { 
        return resolve(this._countriesFullList.value);
      }
      this._countriesStatus = 1;
      this.coreProxyService.IncidentService.EnumITSCountries(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        res => {
          const optionsList: LabelValue<number>[] = [];
          res.forEach(x => {
            let country = {
              label: x.CountryName,
              value: x.CountryID
            };
            optionsList.push(country);
          })
        
          this._countriesList.next(optionsList);
          this._countriesFullList.next(res);
          resolve(res);
        },
        err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    })
  }

  getITSInsuranceCompanies(): Promise<CoreTypes.ITS_InsuranceCompanies[]> {
    return new Promise((resolve, reject) => {
      if (this._insuranceCompaniesFullList.value.length || this._insuranceCompaniesStatus === 1) { 
        return resolve(this._insuranceCompaniesFullList.value);
      }
      this._insuranceCompaniesStatus = 1;
      this.coreProxyService.IncidentService.EnumITSInsuranceCompanies(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {          
          const optionsList: LabelValue<number>[] = [];
          optionsList.push({ label: 'Sin Determinar', value: 0 });
          data.forEach(x => {
            let insuranceCompany = {
              label: x.CompanyName,
              value: x.InsuranceCompanyID
            };
            optionsList.push(insuranceCompany);
          })
        
          this._insuranceCompaniesList.next(optionsList);
          this._insuranceCompaniesFullList.next(data);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err);
        }
      )
    })
  }

  createInsuranceCompany(companyName): Promise<any> {
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.CreateITSInsuranceCompanies(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        companyName,
        data => {
          this._insuranceCompaniesFullList.value.length = 0;
          this._insuranceCompaniesStatus = 0;
          this.getITSInsuranceCompanies();
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err);
        }
      )
    })
  }
  
  getDocumentTypes() {
    return new Promise((resolve, reject) => {
      if (this._documentTypeFullList.value.length || this._documentTypeStatus === 1) { 
        return resolve(this._documentTypeFullList.value);
      }
      this._documentTypeStatus = 1;
      this.coreProxyService.IncidentService.EnumITSDocumentTypes(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.reverse();
          data.forEach((x) => {
            let item = { label: x.DocumentTypeName, value: x.DocumentTypeID };
            optionsList.push(item);
          });
          this._documentTypeFullList.next(data);
          this._documentTypeList.next(optionsList);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getHealthConditions(): Promise<CoreTypes.ITS_HealthConditions[]> {
    let serviceKey = 'HealthConditions';
    return new Promise((resolve, reject) => {
      if (!this._pendingRequests[serviceKey]) {
        this._pendingRequests[serviceKey] = [];
      }
  
      if (this._healthConditionStatus === 2 && this._healthConditionFullList.value.length) {
        return resolve(this._healthConditionFullList.value);
      }
  
      if (this._healthConditionStatus === 1) {
        this._pendingRequests[serviceKey].push(resolve);
        return;
      }
  
      this._healthConditionStatus = 1;
      this._pendingRequests[serviceKey].push(resolve);
      this.coreProxyService.IncidentService.EnumITSHealthConditions(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.reverse();
          data.forEach((x) => {
            let item = { label: x.ConditionName, value: x.HealthConditionID };
            optionsList.push(item);
          });
          this._healthConditionFullList.next(data);
          this._healthConditionList.next(optionsList);
          this._healthConditionStatus = 2;
  
          this._pendingRequests[serviceKey]?.forEach(pendingResolve => pendingResolve(data));
          this._pendingRequests[serviceKey] = [];
        },
        async err => {
          this.appService.showException(err);
          this._pendingRequests[serviceKey] = [];
          this._healthConditionStatus = 0;
          reject(err);
        }
      );
    });
  }
  
  getDamageResponsibilities(): Promise<CoreTypes.ITS_DamageResponsibilities[]>  {
    return new Promise((resolve, reject) => {
      if (this._responsibilitiesFullList.value.length || this._responsibilitiesStatus === 1) { 
        return resolve(this._responsibilitiesFullList.value);
      }
      this._responsibilitiesStatus = 1;
      this.coreProxyService.IncidentService.EnumITSDamageResponsibilities(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.reverse();
          data.forEach((x) => {
            let item = { label: x.ResponsibilityName, value: x.DamageResponsibilityID };
            optionsList.push(item);
          });
          this._responsibilitiesFullList.next(data);
          this._responsibilitiesList.next(optionsList);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getAssistenceTypes(): Promise<CoreTypes.ITS_AssistanceTypes[]> {
    return new Promise((resolve, reject) => {
      if (this._assistenceTypeFullList.value.length || this._assistenceTypeStatus === 1) { 
        return resolve(this._assistenceTypeFullList.value);
      }
      this._assistenceTypeStatus = 1;
      this.coreProxyService.IncidentService.EnumITSAssistanceTypes(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x.AssistanceTypeName, value: x.AssistanceTypeID };
            optionsList.push(item);
          });
          this._assistenceTypeFullList.next(data);
          this._assistenceTypeList.next(optionsList);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getPersonAssistanceReasons(): Promise<CoreTypes.ITS_PersonAssistanceReasons[]> {
    return new Promise((resolve, reject) => {
      if (this._personAssistanceFullList.value.length || this._personAssistanceStatus === 1) { 
        return resolve(this._personAssistanceFullList.value);
      }
      this._personAssistanceStatus = 1;
      this.coreProxyService.IncidentService.EnumITSClientPersonAssistanceReasons(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x.PersonAssistanceReasonDescription , value: x.PersonAssistanceReasonID };
            optionsList.push(item);
          });
          this._personAssistanceFullList.next(data);
          this._personAssistanceList.next(optionsList);
          resolve(data);
        },
        err => {
          this._personAssistanceStatus = 2;
          this.appService.showException(err);
          reject(err);
        }
      );
    }); 
  }

  getPersonTypes() {
    return new Promise((resolve, reject) => {
      if (this._personTypeFullList.value.length || this._personTypeStatus === 1) { 
        return resolve(this._personTypeFullList.value);
      }
      this._personTypeStatus = 1;
      this.coreProxyService.IncidentService.EnumITSPersonTypes(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x.TypeName, value: x.PersonTypeID };
            optionsList.push(item);
          });
          this._personTypeFullList.next(data);
          this._personTypeList.next(optionsList);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  
  getITSHospitals() {
    return new Promise((resolve, reject) => {
      if (this._hospitalsFullList.value.length || this._hospitalsStatus === 1) { 
        return resolve(this._hospitalsFullList.value);
      }
      this._hospitalsStatus = 1;
      this.coreProxyService.IncidentService.EnumITSHospitals(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          optionsList.push({ label: 'Sin Determinar', value: 0 });
          data.forEach((x) => {
            let item = { label: x.HospitalName, value: x.HospitalID };
            optionsList.push(item);
            this._hospitalsFullList.next(data);
            this._hospitalsList.next(optionsList);
            resolve(data);
          });        
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    })
  }

  getPersons(): Promise<CoreTypes.ITS_Persons[]> {
    return new Promise((resolve, reject) => {
      if (this._personsDataFullList.value.length || this._personsDataStatus === 1) { 
        return resolve(this._personsDataFullList.value);
      }
      this._personsDataStatus = 1;
      this.coreProxyService.IncidentService.EnumITSPersons(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x?.FirstName, value: x?.PersonID };
            optionsList.push(item);
          });
          this._personsDataFullList.next(data);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    })
  }

  getITSPersons(personIDs: number[]): Promise<CoreTypes.ITS_Persons[]> {
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.GetITSPersons(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personIDs,
        data => {
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getITSPerson(personID): Promise<CoreTypes.ITS_Persons> {
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.GetITSPerson(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personID,
        data => {
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getITSPersonByIDNumber(documentType, documentNumber) {
    this.coreProxyService.IncidentService.GetITSPersonByIDNumber(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      documentType,
      documentNumber,
      data => {
      },
      async err => {
        this.appService.showException(err);
      }
    );   
  }

  updateITSVehicleData(vehicleDataID:number, vehicleData: CoreTypes.ITS_VehicleSimplifiedData) {
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.UpdateITSVehicleData(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        vehicleDataID,
        vehicleData,
        data => { 
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    })
  }

  updateITSPerson(personID: number, personData: CoreTypes.ITS_Persons):Promise<CoreTypes.ITS_Persons>{
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.UpdateITSPerson(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personID,
        personData,
        data => { 
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    })
  }

  updatePersonContactAddress(personID, contactAddress):Promise<CoreTypes.ITS_Persons>{
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.UpdateITSPersonContactAddress(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personID,
        contactAddress,
        data => { 
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    })
  }

  updatePersonContactPhone(personID, contactPhone):Promise<CoreTypes.ITS_Persons>{
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.UpdateITSPersonContactPhone(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personID,
        contactPhone,
        data => {
          resolve(data);
         },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  updateITSPersonCountry(personID, countryID):Promise<CoreTypes.ITS_Persons>{
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.UpdateITSPersonCountry(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personID,
        countryID,
        data => { 
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    })
  }

  UpdatePersonEmail(personID, email): Promise<CoreTypes.ITS_Persons>{
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.UpdateITSPersonEmail(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personID,
        email,
        data => {
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  updatePersonFullName(personID, firstName, lastName):Promise<CoreTypes.ITS_Persons>{
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.UpdateITSPersonFullName(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personID,
        firstName,
        lastName,
        data => {
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }
  
  updatePersonInsurance(personID, insuranceCompanyID, insurancePolicy, insurancePolicyEffectiveSince, insurancePolicyValidUntil):Promise<CoreTypes.ITS_Persons>{
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.UpdateITSPersonInsurance(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        personID,
        insuranceCompanyID,
        insurancePolicy,
        insurancePolicyEffectiveSince,
        insurancePolicyValidUntil,
        data => {
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getIncidentAttachmentTypes():Promise<CoreTypes.IncidentAttachmentType[]> {
    return new Promise((resolve, reject) => {
      if (this._attachmentTypesFullList.value.length || this._attachmentTypesStatus === 1) { 
        return resolve(this._attachmentTypesFullList.value);
      }
      this._attachmentTypesStatus = 1;
      this.coreProxyService.IncidentService.EnumIncidentAttachmentTypes(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        data => {
          resolve(data);
          this._attachmentTypesFullList.next(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getIncidentMaterialAssets(): Promise<CoreTypes.ITS_MaterialAssets[]> {
    let serviceKey = 'MaterialAssets';
    return new Promise((resolve, reject) => {
      if (!this._pendingRequests[serviceKey]) {
        this._pendingRequests[serviceKey] = [];
      }
  
      if (this._materialAssetsStatus === 2 && this._materialAssetsFullList.value.length) {
        return resolve(this._materialAssetsFullList.value);
      }
  
      if (this._materialAssetsStatus === 1) {
        this._pendingRequests[serviceKey].push(resolve);
        return;
      }
  
      this._materialAssetsStatus = 1;
      this._pendingRequests[serviceKey].push(resolve);
  
      this.coreProxyService.IncidentService.EnumITSClientMaterialAssets(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          data.unshift({
            ClientID: this.appService.getClientID(),
            DateTimeCreated: new CoreTypes.DateTimeDT(),
            DateTimeUpdated: new CoreTypes.DateTimeDT(),
            MaterialAssetDescription: this.appService.CoreCommonLiterals.None_Male,
            MaterialAssetID: 0,
            MultiLangDescription: new CoreTypes.LiteralRecord()
          });
  
          this._materialAssetsFullList.next(data);
          this._materialAssetsStatus = 2;
  
          this._pendingRequests[serviceKey]?.forEach(pendingResolve => pendingResolve(data));
          this._pendingRequests[serviceKey] = [];
        },
        async err => {
          this.appService.showException(err);
          this._materialAssetsStatus = 0;
          this._pendingRequests[serviceKey] = []; 
          reject(err);
        }
      );
    });
  }

  getVehicleAssistanceReasons():Promise<CoreTypes.ITS_VehicleAssistanceReasons[]> {
    return new Promise((resolve, reject) => {
      if (this._assistenceReasonFullList.value.length || this._assistenceReasonStatus === 1) { 
        return resolve(this._assistenceReasonFullList.value);
      }
      this._assistenceReasonStatus = 1;
      this.coreProxyService.IncidentService.EnumITSClientVehicleAssistanceReasons(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x?.VehicleAssistanceReasonDescription, value: x?.VehicleAssistanceReasonID };
            optionsList.push(item);
          });
          this._assistenceReasonList.next(optionsList);
          this._assistenceReasonFullList.next(data);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getDispatchedOwnedEmergencyVehicles(incidentID: number):Promise<CoreTypes.ITS_OwnedEmergencyVehicles[]> {
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.EnumITSIncidentDispatchedOwnedEmergencyVehicles(
        this.appService.getAccessToken(),
        incidentID,
        data => {
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      )
    })
  }

  getDispatchedEmergencyVehicles(incidentID: number):Promise<CoreTypes.ITS_EmergencyVehicles[]> {
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.EnumITSIncidentDispatchedEmergencyVehicles(
        this.appService.getAccessToken(),
        incidentID,
        data => {
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      )
    })
  }

  getSectorList():Promise<CoreTypes.ITS_Sectors[]> {
    return new Promise((resolve, reject) => {
      if (this._sectorFullList.value.length || this._sectorStatus === 1) { 
        return resolve(this._sectorFullList.value);
      }
      this._sectorStatus = 1;
      this.coreProxyService.IncidentService.EnumITSSectors(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x?.SectorName, value: x?.SectorID };
            optionsList.push(item);
          });
          this._sectorList.next(optionsList);
          this._sectorFullList.next(data);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }
  
  getSubSectorList():Promise<CoreTypes.ITS_SubSectors[]> {
    return new Promise((resolve, reject) => {
      if (this._subSectorFullList.value.length || this._subSectorStatus === 1) { 
        return resolve(this._subSectorFullList.value);
      }
      this._subSectorStatus = 1;
      this.coreProxyService.IncidentService.EnumITSSubSectors(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x?.SubSectorName, value: x?.SubSectorID };
            optionsList.push(item);
          });
          this._subSectorList.next(optionsList);
          this._subSectorFullList.next(data);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getSubSectors() {
    return new Promise((resolve, reject) => {
      if (this._subSectorsFullList.value.length || this._subSectorsStatus === 1) { 
        return resolve(this._subSectorsFullList.value);
      }
      this._subSectorsStatus = 1;
      this.coreProxyService.IncidentService.EnumITSSubSectors(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x?.SubSectorName, value: x?.SubSectorID };
            optionsList.push(item);
          });
          this._subSectorsList.next(optionsList);
          this._subSectorsFullList.next(data);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getCommunicationIssuers(parameters: CoreTypes.ITS_CommunicationIssuerParameters):Promise<CoreTypes.ITS_CommunicationIssuers[]>  {
    return new Promise((resolve, reject) => {
      if (this._issuersFullList.value.length || this._issuersStatus === 1) { 
        return resolve(this._issuersFullList.value);
      }
      this._issuersStatus = 1;
      this.coreProxyService.IncidentService.EnumITSCommunicationIssuers(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        parameters,
        data => {
          let optionsList: LabelValue<any>[] = [];
          data.forEach((x) => {
            let item = { 
              label: x?.CommunicationIssuerName ? x.CommunicationIssuerName : x.Description, 
              value: (x?.CommunicationIssuerID ? x.CommunicationIssuerID : x.VehicleID ? x.VehicleID : x.ServiceID) + '-'+ x.ActualType,
              
            };
            optionsList.push(item);
          });
          this._issuersList.next(optionsList);
          this._issuersFullList.next(data);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }  

  getITSCommunicationTypes():Promise<CoreTypes.ITS_CommunicationTypes[]>  {
    return new Promise((resolve, reject) => {
      if (this._communicationTypesFullList.value.length || this._communicationTypesStatus === 1) { 
        return resolve(this._communicationTypesFullList.value);
      }
      this._issuersStatus = 1;
      this.coreProxyService.IncidentService.EnumITSCommunicationTypes(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x?.CommunicationTypeName, value: x?.CommunicationTypeID };
            optionsList.push(item);
          });
          this._communicationTypesList.next(optionsList);
          this._communicationTypesFullList.next(data);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  getITSIncidentOrigins():Promise<CoreTypes.IncidentOrigin[]>  {
    return new Promise((resolve, reject) => {
      if (this._incidentOriginFullList.value.length || this._incidentOriginStatus === 1) { 
        return resolve(this._incidentOriginFullList.value);
      }
      this._incidentOriginStatus = 1;
      this.coreProxyService.IncidentService.EnumITSIncidentOrigins(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          let optionsList: LabelValue<number>[] = [];
          data.forEach((x) => {
            let item = { label: x?.IncidentOriginName, value: x?.IncidentOriginID };
            optionsList.push(item);
          });
          this._incidentOriginList.next(optionsList);
          this._incidentOriginFullList.next(data);
          resolve(data);
        },
        async err => {
          this.appService.showException(err);
          reject(err);
        }
      );
    });
  }

  attachCommunicationsToIncident(incidentID: number, communicationIDs: number[]):Promise<number> {
    if(!incidentID || !communicationIDs?.length) return;
    return new Promise((resolve, reject) => {
      this.coreProxyService.IncidentService.AttachCommunicationsToIncident(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        incidentID,
        communicationIDs,
        data => {
          resolve(data)
        },
        err => {
          this.appService.showException(err);
          reject(err);
        }
      )
    });
  }

  getSelection(sectionId: any): BehaviorSubject<any[]> {
    if (!this.sectionSelections[sectionId]) {
      this.sectionSelections[sectionId] = new BehaviorSubject<any[]>([]);
    }
    return this.sectionSelections[sectionId];
  }

  addItemToSection(sectionId: any, item: any): void {
    const currentSelection = this.getSelection(sectionId).value;
    if (!currentSelection.some(e => e === item)) {
      this.getSelection(sectionId).next([...currentSelection, item]);
    }
  }

  isItemSelectedInSection(sectionId: any, item: any): boolean {
    return this.getSelection(sectionId).value.some(e => e === item);
  }

  removeSelectedItem(sectionId, item: any): void {
    const currentSelection = this.getSelection(sectionId).value.filter(e => e !== item);
    this.getSelection(sectionId).next([]);
    this.getSelection(sectionId).next(currentSelection);
  }

  setMinDate(dateFrom) {
    let minDate = new Date();
    minDate.setDate(dateFrom.Date.Day);
    minDate.setMonth(dateFrom.Date.Month-1);
    minDate.setFullYear(dateFrom.Date.Year);
    minDate.setHours(dateFrom.Time.Hour);
    minDate.setMinutes(dateFrom.Time.Minute);
    minDate.setSeconds(dateFrom.Time.Second +10);
    minDate.setMilliseconds(dateFrom.Time.Millisecond);
    return minDate;
  }

  cleanVariablesClient() {
    this._incidentTypeFullList.value.length = 0;
    this._incidentTypeStatus = 0;
    this._prioritiesFullList.value.length = 0;
    this._prioritiesStatus = 0;
    this._incidentStatusFullList.value.length = 0;
    this._incidentStatus = 0;
    this._assistenceReasonFullList.value.length = 0;
    this._assistenceReasonStatus = 0;
    this._personAssistanceFullList.value.length = 0;
    this._personAssistanceStatus = 0;
  }

  cleanVariablesFacility() {
    this._assetsFullList.value.length = 0;
    this._assetsStatus = 0;
    this._externalServiceFullList.value.length = 0;
    this._externalServiceStatus = 0;
    this._vialAxesFullList.value.length = 0;
    this._vialAxesStatus = 0;
    this._geozonesList.value.length = 0;
    this._geozonesStatus = 0;
    this._vehicleModelsFullList.value.length = 0;
    this._vehicleModelsStatus = 0;
    this._vehicleMakesFullList.value.length = 0;
    this._vehicleMakesStatus = 0;
    this._vehicleColorFullList.value.length = 0;
    this._vehicleColorStatus = 0;
    this._vehicleTypesFullList.value.length = 0;
    this._vehicleTypesStatus = 0;
    this._vehicleDataFullList.value.length = 0;
    this._vehicleDataStatus = 0;
    this._trafficDirectionsFullList.value.length = 0;
    this._trafficDirectionsStatus = 0;
    this._countriesFullList.value.length = 0;
    this._countriesStatus = 0;
    this._insuranceCompaniesFullList.value.length = 0;
    this._insuranceCompaniesStatus = 0;
    this._personTypeFullList.value.length = 0;
    this._personTypeStatus = 0;
    this._assistenceTypeFullList.value.length = 0;
    this._assistenceTypeStatus = 0;
    this._hospitalsFullList.value.length = 0;
    this._hospitalsStatus = 0;
    this._reasonCloseFullList.value.length = 0;
    this._reasonCloseStatus = 0;
    this._hospitalsStatus = 0;
    this._reasonOpenFullList.value.length = 0;
    this._reasonOpenStatus = 0;
    this._documentTypeFullList.value.length = 0;
    this._documentTypeStatus = 0;
    this._healthConditionFullList.value.length = 0;
    this._healthConditionStatus = 0;
    this._responsibilitiesFullList.value.length = 0;
    this._responsibilitiesStatus = 0;
    this._personsDataFullList.value.length = 0;
    this._personsDataStatus = 0;
    this._attachmentTypesFullList.value.length = 0;
    this._attachmentTypesStatus = 0;
    this._materialAssetsFullList.value.length = 0;
    this._materialAssetsStatus = 0;
    this._roadwaysFullList.value.length = 0;
    this._roadwaysStatus = 0;
    this._roadwayLanesFullList.value.length = 0;
    this._roadwayLanesStatus = 0;
    this._lanesFullList.value.length = 0;
    this._lanesStatus = 0;
    this._sectorFullList.value.length = 0;
    this._sectorStatus = 0;
    this._subSectorFullList.value.length = 0;
    this._subSectorStatus = 0;
    this._subSectorsFullList.value.length = 0;
    this._subSectorsStatus = 0;
    this._issuersFullList.value.length = 0;
    this._issuersStatus = 0;
    this._communicationTypesFullList.value.length = 0;
    this._communicationTypesStatus = 0;
    this._incidentOriginFullList.value.length = 0;
    this._incidentOriginStatus = 0;
    this._incidentSubTypeFullList.value.length = 0;
    this._incidentSubTypeStatus = 0;
    this._pendingRequests = {}; 
  }
  
  getIcon(color, icon) {
    switch (icon) {
      case 0:
      default:
        return ` 
          <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
            <defs>
              <style>
                .cls-1 {
                  fill: ${color};
                }
                .cls-1, .cls-2 {
                  stroke-width: .5px;
                  stroke: #444;
                }
                .cls-2 {
                  fill: #444;
                }
              </style>
            </defs>
            <path class="cls-1" d="M256.13,473.55c-59,0-118-.25-176.99.11-29.69.18-53.05-10.92-67.45-37.1-14.31-26.01-12.01-51.81,3.79-76.99,59.56-94.95,118.53-190.29,178.38-285.05,30.83-48.8,94.31-47.97,125.07,1.07,59.27,94.51,118.16,189.27,177.46,283.77,15.79,25.16,18.34,50.8,4.01,76.95-14.4,26.25-37.54,37.49-67.27,37.3-59-.37-117.99-.11-176.99-.11v.06ZM254.07,448.01v-.09c59.52,0,119.05-.19,178.57.11,19.67.1,35.54-6.22,45.28-23.89,9.66-17.52,7.31-34.53-3.13-51.2-59.23-94.53-118.21-189.21-177.47-283.72-21.17-33.75-61.88-33.31-83.15.69-58.59,93.68-116.92,187.53-175.76,281.05-11.19,17.79-14.45,35.41-3.81,53.94,10.36,18.05,27.14,23.46,47.29,23.29,57.39-.49,114.79-.17,172.19-.17Z"/>
            <path class="cls-2" d="M254.07,448.01c-57.4,0-114.8-.32-172.19.17-20.15.17-36.93-5.24-47.29-23.29-10.64-18.52-7.38-36.15,3.81-53.94,58.84-93.52,117.17-187.37,175.76-281.05,21.27-34.01,61.99-34.44,83.15-.69,59.27,94.5,118.25,189.19,177.47,283.72,10.44,16.67,12.79,33.68,3.13,51.2-9.74,17.68-25.6,23.99-45.28,23.89-59.52-.3-119.05-.11-178.57-.11v.09ZM256.16,427.14c57.39,0,114.77-.09,172.16.07,12.72.04,24.65-.91,31.53-13.76,6.86-12.81.95-23.24-5.79-33.99-57.27-91.33-114.36-182.77-171.46-274.21-16.8-26.91-36.28-26.91-53.32.32-57.18,91.39-114.23,182.85-171.48,274.2-6.72,10.72-12.68,21.11-5.5,33.94,7.12,12.73,19.05,13.53,31.71,13.49,57.39-.14,114.77-.06,172.16-.06Z"/>
            <path class="cls-1" d="M256.16,427.14c-57.39,0-114.77-.08-172.16.06-12.66.03-24.58-.77-31.71-13.49-7.18-12.83-1.22-23.22,5.5-33.94,57.24-91.35,114.3-182.81,171.48-274.2,17.04-27.23,36.52-27.23,53.32-.32,57.1,91.44,114.19,182.88,171.46,274.21,6.74,10.75,12.65,21.18,5.79,33.99-6.88,12.85-18.81,13.8-31.53,13.76-57.39-.16-114.77-.07-172.16-.07ZM281.73,206.47c.27.01.55.02.82.03,0-3.18-.12-6.36.02-9.53.99-22.51-9.69-37.75-26.48-37.69-17.04.06-28.11,14.89-26.59,37.55,2.74,40.69,6.22,81.33,9.37,122,.82,10.58,6.22,16.92,17.05,16.95,11.89.03,16.65-7.45,17.46-18.4,2.76-36.97,5.56-73.94,8.35-110.92ZM282.77,374.41c-.16-14.3-12.27-26.24-26.68-26.28-15.02-.05-27.16,12.49-26.82,27.69.34,14.7,11.88,26.12,26.53,26.22,15.08.11,27.13-12.24,26.96-27.63Z"/>
            <path class="cls-2" d="M281.73,206.47c-2.79,36.97-5.59,73.94-8.35,110.92-.82,10.95-5.57,18.43-17.46,18.4-10.83-.03-16.23-6.37-17.05-16.95-3.15-40.66-6.63-81.31-9.37-122-1.53-22.66,9.54-37.5,26.59-37.55,16.79-.06,27.48,15.18,26.48,37.69-.14,3.17-.02,6.35-.02,9.53-.27-.01-.55-.02-.82-.03Z"/>
            <path class="cls-2" d="M282.77,374.41c.17,15.39-11.88,27.74-26.96,27.63-14.65-.11-26.2-11.52-26.53-26.22-.35-15.2,11.8-27.74,26.82-27.69,14.4.05,26.52,11.98,26.68,26.28Z"/>
          </svg>`
        break;
      case 1:
        return ` 
          <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 18 22">
            <defs>
              <style>
                .cls-1 {
                  fill: ${color};
                }
                .cls-1, .cls-2 {
                  stroke-width: .5px;
                  stroke: #444;
                }
                .cls-2 {
                  fill: #444;
                }
              </style>
            </defs>
            <g>
              <path class="cls-1" d="M10.38.25c-.47-.11-.93-.16-1.37-.16h-.03c-.43,0-.88.05-1.35.16C3.84,1.12,1.21,4.57,1.36,8.46c.23,6.04,5.88,11.8,7.64,13.45,1.76-1.65,7.41-7.41,7.64-13.45.15-3.89-2.48-7.34-6.26-8.21ZM9.03,13.4h-.03s-.03,0-.03,0c-3.2-.02-5.8-2.63-5.8-5.83S5.78,1.75,8.99,1.74h.02c3.21,0,5.82,2.62,5.82,5.83s-2.6,5.82-5.8,5.83Z"/>
              <path class="cls-1" d="M12.56,6.12l-.52-1.37c-.16-.41-.52-.68-.93-.68h-4.22c-.41,0-.77.27-.93.68l-.52,1.37c-.03-.07-.1-.12-.18-.12h-.52c-.09,0-.16.07-.16.16v.24c0,.09.07.16.16.16h.45s.07.04.06.08l-.1.26h0l-.07.18c-.08.25-.12.65-.12.91v1.05s0,.1,0,.1c0,0,0,0,0,0v1.3c0,.11.09.2.2.2h.91c.11,0,.2-.09.2-.2v-.45h5.49v.45c0,.11.09.2.2.2h.91c.11,0,.2-.09.2-.2v-1.3s0,0,0,0v-.11s0-.05,0-.05v-.99s0,0,0,0c0-.26-.04-.65-.12-.9l-.07-.18h0l-.1-.26s.01-.08.06-.08h.45c.09,0,.16-.07.16-.16v-.24c0-.09-.07-.16-.16-.16h-.52c-.08,0-.15.05-.18.12ZM5.84,6.4l.51-1.39c.1-.29.31-.48.55-.48h4.22c.24,0,.45.19.55.48l.51,1.39c.08.22-.08.46-.32.46h-5.68c-.24,0-.4-.24-.32-.46ZM6.48,9.04h-.7c-.28,0-.5-.22-.5-.5v-.51h.54c.46,0,.83.37.83.83,0,.09-.08.17-.17.17ZM10.47,8.88c0,.18-.15.33-.33.33h-2.25c-.18,0-.33-.15-.33-.33v-.53c0-.18.15-.33.33-.33h2.25c.18,0,.33.15.33.33v.53ZM12.73,8.53c0,.28-.22.5-.5.5h-.7c-.09,0-.17-.08-.17-.17v-.11c0-.4.32-.72.72-.72h.65v.51Z"/>
            </g>
            <path class="cls-2" d="M8.62,17.67c0,.49,0,.98,0,1.46,0,.27.15.43.39.43.22,0,.36-.16.36-.43,0-.9,0-1.81,0-2.71,0-.07,0-.14,0-.25.08.06.12.1.16.14.25.25.5.51.76.75.17.16.38.16.53,0,.15-.15.16-.37,0-.53-.51-.52-1.02-1.03-1.54-1.54-.17-.17-.4-.16-.57,0-.51.5-1.01,1-1.51,1.51-.17.17-.17.39-.02.55.16.16.38.16.56-.02.3-.29.59-.59.88-.89,0,.51,0,1.01,0,1.52Z"/>
          </svg>`
        break;
      case 2:
        return ` 
          <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 18 22">
            <defs>
              <style>
                .cls-1 {
                  fill: ${color};
                }
                .cls-1, .cls-2 {
                  stroke-width: .5px;
                  stroke: #444;
                }
                .cls-2 {
                  fill: #444;
                }
              </style>
            </defs>
            <g>
              <path class="cls-1" d="M10.38.23c-.47-.11-.93-.16-1.37-.16h-.03c-.43,0-.89.05-1.36.16C3.83,1.1,1.19,4.56,1.34,8.45c.23,6.05,5.9,11.83,7.66,13.48,1.76-1.65,7.42-7.43,7.66-13.48.15-3.89-2.49-7.35-6.28-8.22ZM9.03,13.41h-.03s-.03,0-.03,0c-3.21-.02-5.82-2.64-5.82-5.84S5.77,1.73,8.99,1.72h.02c3.22,0,5.84,2.63,5.84,5.84s-2.61,5.83-5.82,5.84Z"/>
              <path class="cls-1" d="M12.57,6.11l-.52-1.38c-.16-.41-.52-.68-.93-.68h-4.23c-.41,0-.77.27-.93.68l-.52,1.38c-.03-.07-.1-.12-.18-.12h-.52c-.09,0-.16.07-.16.16v.24c0,.09.07.16.16.16h.45s.07.04.06.08l-.1.26h0l-.07.18c-.08.25-.12.65-.12.91v1.05s0,.1,0,.1c0,0,0,0,0,0v1.3c0,.11.09.2.2.2h.91c.11,0,.2-.09.2-.2v-.45h5.5v.45c0,.11.09.2.2.2h.91c.11,0,.2-.09.2-.2v-1.3s0,0,0,0v-.11s0-.05,0-.05v-.99s0,0,0,0c0-.26-.04-.65-.12-.9l-.07-.18h0l-.1-.26s.01-.08.06-.08h.45c.09,0,.16-.07.16-.16v-.24c0-.09-.07-.16-.16-.16h-.52c-.08,0-.15.05-.18.12ZM5.83,6.39l.51-1.39c.1-.29.31-.48.55-.48h4.23c.24,0,.45.19.55.48l.51,1.39c.08.22-.08.46-.32.46h-5.7c-.24,0-.4-.24-.32-.46ZM6.47,9.03h-.71c-.28,0-.5-.22-.5-.5v-.51h.54c.46,0,.84.37.84.84,0,.09-.08.17-.17.17ZM10.47,8.87c0,.18-.15.33-.33.33h-2.25c-.18,0-.33-.15-.33-.33v-.53c0-.18.15-.33.33-.33h2.25c.18,0,.33.15.33.33v.53ZM12.74,8.52c0,.28-.22.5-.5.5h-.71c-.09,0-.17-.08-.17-.17v-.11c0-.4.33-.73.73-.73h.65v.51Z"/>
            </g>
            <path class="cls-2" d="M8.62,16.77c0-.49,0-.98,0-1.47,0-.27.15-.43.39-.43.22,0,.36.16.36.43,0,.9,0,1.81,0,2.71,0,.07,0,.14,0,.25.08-.06.12-.1.16-.14.25-.25.5-.51.76-.75.17-.16.38-.16.53,0,.15.15.16.37,0,.53-.51.52-1.02,1.03-1.54,1.54-.17.17-.4.16-.57,0-.51-.5-1.01-1.01-1.51-1.51-.17-.18-.18-.39-.02-.55.16-.16.38-.16.56.02.3.29.59.59.88.89,0-.51,0-1.01,0-1.52Z"/>
          </svg>`
        break;
      case 3:
          return `<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 18 22">
            <defs>
              <style>
                .cls-1 {
                  fill: ${color};
                }
                .cls-1, .cls-2 {
                  stroke-width: .5px;
                  stroke: #444;
                }
                .cls-2 {
                  fill: #444;
                }
              </style>
            </defs>
            <g>
              <path class="cls-1" d="M10.38.25c-.47-.11-.93-.16-1.37-.16h-.03c-.43,0-.88.05-1.35.16C3.84,1.12,1.21,4.57,1.36,8.46c.23,6.04,5.88,11.8,7.64,13.45,1.76-1.65,7.41-7.41,7.64-13.45.15-3.89-2.48-7.34-6.26-8.21ZM9.03,13.4h-.03s-.03,0-.03,0c-3.2-.02-5.8-2.63-5.8-5.83S5.78,1.75,8.99,1.74h.02c3.21,0,5.82,2.62,5.82,5.83s-2.6,5.82-5.8,5.83Z"/>
              <path class="cls-1" d="M12.56,6.12l-.52-1.37c-.16-.41-.52-.68-.93-.68h-4.22c-.41,0-.77.27-.93.68l-.52,1.37c-.03-.07-.1-.12-.18-.12h-.52c-.09,0-.16.07-.16.16v.24c0,.09.07.16.16.16h.45s.07.04.06.08l-.1.26h0l-.07.18c-.08.25-.12.65-.12.91v1.05s0,.1,0,.1c0,0,0,0,0,0v1.3c0,.11.09.2.2.2h.91c.11,0,.2-.09.2-.2v-.45h5.49v.45c0,.11.09.2.2.2h.91c.11,0,.2-.09.2-.2v-1.3s0,0,0,0v-.11s0-.05,0-.05v-.99s0,0,0,0c0-.26-.04-.65-.12-.9l-.07-.18h0l-.1-.26s.01-.08.06-.08h.45c.09,0,.16-.07.16-.16v-.24c0-.09-.07-.16-.16-.16h-.52c-.08,0-.15.05-.18.12ZM5.84,6.4l.51-1.39c.1-.29.31-.48.55-.48h4.22c.24,0,.45.19.55.48l.51,1.39c.08.22-.08.46-.32.46h-5.68c-.24,0-.4-.24-.32-.46ZM6.48,9.04h-.7c-.28,0-.5-.22-.5-.5v-.51h.54c.46,0,.83.37.83.83,0,.09-.08.17-.17.17ZM10.47,8.88c0,.18-.15.33-.33.33h-2.25c-.18,0-.33-.15-.33-.33v-.53c0-.18.15-.33.33-.33h2.25c.18,0,.33.15.33.33v.53ZM12.73,8.53c0,.28-.22.5-.5.5h-.7c-.09,0-.17-.08-.17-.17v-.11c0-.4.32-.72.72-.72h.65v.51Z"/>
            </g>
            <path class="cls-2" d="M8.55,16.29c-.49,0-.98,0-1.46,0-.27,0-.43.15-.43.39,0,.22.16.36.43.36.9,0,1.81,0,2.71,0,.07,0,.14,0,.25,0-.06.08-.1.12-.14.16-.25.25-.51.5-.75.76-.16.17-.16.38,0,.53.15.15.37.16.53,0,.52-.51,1.03-1.02,1.54-1.54.17-.17.16-.4,0-.57-.5-.51-1-1.01-1.51-1.51-.17-.17-.39-.17-.55-.02-.16.16-.16.38.02.56.29.3.59.59.89.88-.51,0-1.01,0-1.52,0Z"/>
          </svg>`
        break;
      case 4:
          return `
          <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 18 22">
            <defs>
              <style>
                .cls-1 {
                 fill: ${color};
                }
                .cls-1, .cls-2 {
                  stroke-width: .5px;
                  stroke: #444;
                }
                .cls-2 {
                  fill: #444;
                }
              </style>
            </defs>
            <g>
              <path class="cls-1" d="M10.37.34c-.47-.11-.92-.16-1.36-.16h-.03c-.43,0-.88.05-1.34.16C3.88,1.2,1.27,4.62,1.42,8.48c.23,5.99,5.84,11.71,7.58,13.34,1.74-1.64,7.35-7.35,7.58-13.34.15-3.86-2.47-7.28-6.22-8.14ZM9.03,13.39h-.03s-.03,0-.03,0c-3.17-.02-5.76-2.61-5.76-5.79S5.8,1.82,8.99,1.81h.02c3.19,0,5.78,2.6,5.78,5.79s-2.58,5.77-5.76,5.79Z"/>
              <path class="cls-1" d="M12.53,6.16l-.52-1.36c-.16-.41-.52-.67-.92-.67h-4.18c-.4,0-.77.26-.92.67l-.52,1.36c-.03-.07-.1-.12-.18-.12h-.51c-.09,0-.16.07-.16.16v.23c0,.09.07.16.16.16h.44s.07.04.06.08l-.1.26h0l-.07.17c-.08.25-.11.64-.11.9v1.04s0,.1,0,.1c0,0,0,0,0,0v1.29c0,.11.09.19.19.19h.9c.11,0,.19-.09.19-.19v-.45h5.45v.45c0,.11.09.19.19.19h.9c.11,0,.19-.09.19-.19v-1.29s0,0,0,0v-.11s0-.05,0-.05v-.98s0,0,0,0c0-.26-.04-.65-.11-.89l-.07-.17h0l-.1-.26s.01-.08.06-.08h.44c.09,0,.16-.07.16-.16v-.23c0-.09-.07-.16-.16-.16h-.51c-.08,0-.15.05-.18.12ZM5.86,6.44l.51-1.38c.1-.29.31-.47.54-.47h4.18c.23,0,.45.19.54.47l.51,1.38c.08.22-.08.46-.32.46h-5.64c-.24,0-.4-.24-.32-.46ZM6.5,9.05h-.7c-.27,0-.5-.22-.5-.5v-.5h.54c.46,0,.83.37.83.83,0,.09-.08.17-.17.17ZM10.46,8.89c0,.18-.15.33-.33.33h-2.23c-.18,0-.33-.15-.33-.33v-.52c0-.18.15-.33.33-.33h2.23c.18,0,.33.15.33.33v.52ZM12.7,8.54c0,.27-.22.5-.5.5h-.7c-.09,0-.17-.08-.17-.17v-.11c0-.4.32-.72.72-.72h.64v.5Z"/>
            </g>
            <path class="cls-2" d="M9.45,16.25c.48,0,.97,0,1.45,0,.27,0,.43.15.42.38,0,.22-.16.36-.42.36-.9,0-1.79,0-2.69,0-.07,0-.14,0-.25,0,.06.07.1.12.14.16.25.25.5.5.75.75.16.16.16.38,0,.53-.15.15-.37.16-.53,0-.51-.5-1.02-1.01-1.53-1.52-.16-.17-.16-.39,0-.56.5-.5,1-1,1.5-1.5.17-.17.39-.17.54-.02.16.16.16.37-.02.56-.29.29-.59.58-.88.87.5,0,1,0,1.51,0Z"/>
          </svg>`
        break;
    }
  }

}
